// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const DiscountCircleIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "DiscountCircle/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 1.667A8.336 8.336 0 0 0 1.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667Zm-2.5 5c.458 0 .833.375.833.833a.83.83 0 0 1-.833.833.836.836 0 0 1-.833-.833c0-.458.375-.833.833-.833Zm.442 6.275a.618.618 0 0 1-.442.183.618.618 0 0 1-.442-.183.629.629 0 0 1 0-.884l5-5a.629.629 0 0 1 .884 0 .629.629 0 0 1 0 .884l-5 5Zm4.558.391a.838.838 0 0 1-.842-.833c0-.458.375-.833.834-.833.458 0 .833.375.833.833a.829.829 0 0 1-.825.833Z"
}));
export default DiscountCircleIcon;